import React from 'react'
import { Row, Col, Card } from 'react-bootstrap';
import StatusContext from '../../../contexts/StatusContext';
import './aboutus.css'

export const AboutUs = () => {

  let {
    changeLanguage,
  } = React.useContext(StatusContext);


  return (

    <div className="homeContainer">

      <div className="homenewMainTitle" >
        DedaAI
      </div>

      <div className="homenewMainSubtitle" >
        {changeLanguage('home', 'moto')}
      </div>
      <br></br>
      <br></br>

      <Row>
        <Col>

          <div className="homenewHeader">
            <div className="homenewHeaderTitle" style={{ color: 'maroon', fontSize: '18px', fontWeight: '500' }}>
              At DedaAI, we use artificial intelligence (AI) and strategic consulting to help businesses improve and innovate. Whether you want to streamline operations, improve customer experiences, or turn data into useful insights, we're here to support you on your path to success.
            </div>

          </div>

          <div className="homenewHeader">

            <div className="homenewHeaderTitle" style={{ color: 'maroon', fontSize: '18px', fontWeight: '500' }}>
              Domain expertise is key to AI success in the physical world, and we are here to help achieve it.
            </div>
          </div>
          <br></br>
          <br></br>
          <div className="homenewText">

            <div className='homenewTopic'>
              {changeLanguage('aitest', 'text30')}

            </div>
            <div className="homecontainerTextWithIcon">
              <div className="homeWithIconTextArea">
                {changeLanguage('aitest', 'text31')}
              </div>
            </div>

            <br></br>


            <div className='homenewTopic'>
              {changeLanguage('aitest', 'text32')}

            </div>
            <div className="homecontainerTextWithIcon">
              <div className="homeWithIconTextArea">
                {changeLanguage('aitest', 'text33')}
              </div>
            </div>

            <br></br>

            <div className='homenewTopic'>
              {changeLanguage('aitest', 'text34')}
            </div>
            <div className="homecontainerTextWithIcon">
              <div className="homeWithIconTextArea">
                {changeLanguage('aitest', 'text35')}
              </div>
            </div>

            <br></br>

            <div className='homenewTopic'>
              {changeLanguage('aitest', 'text36')}
            </div>
            <div className="homecontainerTextWithIcon">
              <div className="homeWithIconTextArea">
                {changeLanguage('aitest', 'text37')}
              </div>
            </div>

            <br></br>

          </div>

        </Col>
      </Row>
      <br></br>


      <Row>
        <Col>
          <Card>
            <Card.Body style={{ backgroundColor: 'transparent', border: 'none' }}>
              <Card.Title ></Card.Title>
              <Card.Text>
                <div className="aboutusFooter">

                  <div className="aboutusfooterLeft">
                    DedaAI LLC, Chicago USA
                  </div>

                  <div className="aboutusfooterRight">Contact us: info@dedaai.com</div>
                </div>

              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>


  )
}

export default AboutUs